import { useTranslation } from 'react-i18next';
import {
  formatSpecification,
  trimDecimalZero,
} from '../../../utils/commonUtils';
import i18next from 'i18next';
import { convertTo12HourFormat } from '../../../utils/dateUtils';

export const t = (key) => i18next.t(key, { ns: 'Order' });
export const handlePrintOrderInfo = async (orders, isOrdersCatering) => {
  // Create a new window for printing
  const isAndroid = /Android/i.test(navigator.userAgent);
  const printScript = `<script>
       
  window.onload = function () {
    window.focus();
    window.print();

    window.onafterprint = function () {
      window.close();
    };

    // Fallback in case onafterprint doesn't fire
    setTimeout(function () {
      window.close();
    }, 1000);
  };
</script>`;
  // Write the HTML structure with inline styles
  const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${t('ORDERDETAILS')}</title>
          <style>
            // @page {
            //   size: A4 portrait;
            // }

            body { margin: 0; padding: 15px; font-family: Arial, sans-serif; }
            // .print-order-details { width: 100%; page-break-after: always; }
            .header { text-align: center; padding-bottom: 40px;padding-top: 60px; }
            .header h1 { font-size: 24px; margin: 0; }
            .order-info { margin-bottom: 10px; }
            .info-section { padding: 10px; }
            .info-section ul { list-style: none; padding: 0; margin: 0; }
            .info-section li { display: flex; align-items: center; margin-bottom: 10px; }
            .info-section p { margin: 0; font-weight: bold; min-width: 150px;font-size: 18px; }
            .info-section span { margin: 0 10px; }
            .info-section2 { padding: 5px 10px!important;}
            .info-section h3 { margin: 0; font-weight: normal; width: 113px;font-size: 15px;word-break: break-word;}
            .products-info { margin: 10px; }
           .fw-bold { font-weight: 700; }
            .products-info h2 { font-size: 20px; margin-bottom: 5px; }
            .table { width: 100%; border-collapse: collapse; }
            .table td{font-size: 21px;}
            .table th, .table td { padding: 8px; border: 2px solid #dee2e6; text-align: left; }
            .table th { background-color: #f8f9fa; font-weight: bold;font-size: 19px; }
            .info-section.info-section2 p{font-size: 25px;min-width: 223px;}
           .info-section.info-section2 h3{font-size: 23px;}
            
           .print-order-details {
            page-break-inside: avoid;
            break-inside: avoid;
            // page-break-before: always;
          }
            .print-order-details:not(:first-child) {
            page-break-before: always;
          }

          .sr-no{width: 50px;}
          .product-code{width: 105px;}
          .product-name{width: 300px;}
          .origin{width: 100px;}
          .specification{width: 200px;}
          .qty{width: 110px;}
          .remark{width: 230px;}
          .process{width: 150px;}
          @media print {
            @page {
              margin: 0;
              padding:0;
            }
          </style>
        </head>
        <body>
          ${orders
            .map(
              (order, orderIndex) => `
            <div class="print-order-details">
              <div class="header">
                <h1>Order Details ${`- #${order.number}`}</h1>
              </div>
              <div class="order-info">
                <div style="display: flex; gap: 20px;">
                  <div class="info-section" style="flex: 1; border-right: 2px solid #dee2e6;">
                    <ul>
                      <li><p>${t('DELIVERYDATE')}</p><span>-</span><h3>${order?.delivery_date || ''}</h3></li>
                      <li><p>${t('CUSTOMERCODE')}</p><span>-</span><h3>${order?.customer?.code || ''}</h3></li>
                      <li><p>${t('CUSTOMERNAME')}</p><span>-</span><h3>${order?.customer?.name || ''}</h3></li>
                      <li><p>${t('REFERENCENUMBER')}</p><span>-</span><h3>${order?.reference_number || ''}</h3></li>
                      ${
                        !isOrdersCatering
                          ? `
                      <li><p>${t('PONUMBER')}</p><span>-</span><h3>${order?.po_number || ''}</h3></li>`
                          : ''
                      }
                    </ul>
                  </div>
                          <div class="info-section" style="flex: 1; border-right: 2px solid #dee2e6;">
                    <ul>
                      <li><p>${t('DISTRICT')}</p><span>-</span><h3>${order?.district?.name || ''}</h3></li>
                         <li><p>${t('AREA')}</p><span>-</span><h3>${order?.area?.name || ''}</h3></li>
                        <li><p>${t('LOGISTICLINE')}</p><span>-</span><h3>${order?.logistic_line?.name || ''}</h3></li>
                        <li><p>${t('CONTACTPERSON')}</p><span>-</span><h3>${order?.contact_name || ''}</h3></li>
                         <li><p>${t('CONTACTPHONE')}</p><span>-</span><h3>${order?.contact_phone || ''}</h3></li>     
                    </ul>
                  </div>
                  <div class="info-section" style="flex: 1;">
                    <ul>
                      <li><p>${t('PAYMENTMETHOD')}</p><span>-</span><h3>${order?.payment_method?.name || ''}</h3></li>
                      <li><p>${t('PAYMENTSTATUS')}</p><span>-</span><h3>${order?.payment_status?.name || ''}</h3></li>
                      <li><p>${t('PAYMENTDATE')}</p><span>-</span><h3>${order?.payment_date || ''}</h3></li>
                      ${
                        !isOrdersCatering
                          ? `
                      <li><p>${t('EARLIESTDELIVERYTIME')}</p><span>-</span><h3>${order?.earliest_delivery_time ? convertTo12HourFormat(order.earliest_delivery_time) : '--:--'}</h3></li>
                      <li><p>${t('LATESTDELIVERYTIME')}</p><span>-</span><h3>${order?.latest_delivery_time ? convertTo12HourFormat(order.latest_delivery_time) : '--:--'}</h3></li>`
                          : ''
                      }
                    </ul>
                  </div>
                </div>
                     <div style="display: flex; gap: 20px;">
                  <div class="info-section info-section2" style="flex: 1;">
                    <ul>
                   <li><p>${t('DELIVERYADDRESS')}</p><span>-</span><h3 style="width: 100%; font-weight: 600;">${order?.delivery_address || ''}</h3></li>
                    <li><p>${t('ORDERREMARK')}</p><span>-</span><h3 style="width: 100%;font-weight: 600;">${order?.remark || ''}</h3></li>
                      </ul>
                       </div>
                        </div>
              </div>
              <div class="products-info">
                <h2>${t('PRODUCTSINFO')}</h2>
                <table class="table">
                  <thead>
                    <tr>
                      <th class="sr-no">#</th>
                      <th class="product-code">${t('PRODUCTCODE')}</th>
                      <th class="product-name">${t('PRODUCTNAME')}</th>
                      <th class="origin">${t('ORIGIN')}</th>
                      <th class="specification">${t('SPECIFICATION')}</th>
                      <th class="qty">${t('QUANTITY')}</th>
                      <th class="remark">${t('PRODUCTREMARK')}</th>
                      <th class="process">${t('PROCESSLOCATION')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${order?.products
                      ?.map(
                        (product, index) => `
                      <tr>
                        <td class="sr-no">${index + 1}</td>
                        <td class="product-code">${product?.product_code || ''}</td>
                        <td class="fw-bold">${product?.product_name || ''}</td>
                        <td class="origin">${product?.origin?.name || ''}</td>
                        <td class="specification">${formatSpecification(product)}</td>
                        <td class="qty">${trimDecimalZero(product?.quantity)}</td>
                        <td class="fw-bold remark">${product?.remarks || ''}</td>
                        <td class="process">${product?.process_location?.name || ''}</td>
                      </tr>
                    `
                      )
                      .join('')}
                  </tbody>
                </table>
              </div>
            </div>
          `
            )
            .join('')}
          ${isAndroid ? '' : printScript}
</body>
</html>

    `;

  if (isAndroid) {
    // const originalContent = document.body.innerHTML;
    // document.body.innerHTML = printContent;

    const originalContent = document.documentElement.innerHTML;
    document.documentElement.innerHTML = printContent;
    let afterPrintTriggered = false;
    let focusTriggered = false;

    function tryRestore() {
      if (afterPrintTriggered && focusTriggered) {
        // document.body.innerHTML = originalContent;
        document.documentElement.innerHTML = originalContent;
        window.location.reload(); // Optional
        // cleanup
        window.onafterprint = null;
        window.onfocus = null;
      }
    }

    setTimeout(() => {
      window.print();

      window.onafterprint = () => {
        afterPrintTriggered = true;
        tryRestore();
      };

      window.onfocus = () => {
        focusTriggered = true;
        tryRestore();
      };
    }, 500);
  } else {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
  }
};
